import { DOCUMENT_DROP_ZONE_HEIGHT } from '@/components/dashboard/dashboardLayout'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

/** Loading placeholder that mirrors the dashed upload zone layout. */
export function FileDropZoneSkeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-border/70 bg-muted/20 px-4 py-5 text-center',
        DOCUMENT_DROP_ZONE_HEIGHT,
        className,
      )}
    >
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
        <Skeleton className="h-5 w-5 rounded-md" />
      </span>
      <Skeleton className="h-4 w-48 max-w-full" />
      <Skeleton className="h-3 w-56 max-w-[85%]" />
    </div>
  )
}
